
import React, { useEffect, useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm } from '../forms/useForm';
import { sendRequest } from '../requests/useRequest';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { validarSesion } from '../tokens/useToken';
import { usePagination } from '../pagination/usePagination';
import * as XLSX from 'xlsx';

export const useInfoAnalytes = () => {

    const history = useHistory();

    const [analytes, setAnalytes] = useState([]);
    const [analyteId, setAnalyteId] = useState(0);

    const [method, setMethod] = useState("");
    const [modal, setModal] = useState(false);
    const [modalTitle, setModalTitle] = useState("");

    const [loading, setLoading] = useState(false);
    const [createSweet, sweetConfirmation,sweetDelete, sweetError, createSweett, sweetConfirmationUpdate] = useSweetAlert();

    const [formValues, handleInputChange, reset, handleUpdateValues] = useForm({
        name: "",
        code: "",
        is_interfaced: true
    });


    const { name, code, is_interfaced } = formValues;

    const [validaciones, setValidaciones] = useState({
        name_valid: false,
        code_valid: false,
    });

    const toggle = () => {
        setModal(!modal);
    }


    const getInfoAnalytes = useCallback(async () => {
        let requestOptions = {
            method: 'GET'
        };

        //let listAnalyte = [];
        const respuesta = await sendRequest(requestOptions, "InfoAnalyte/ListAnalytes");
        console.log("🚀 ~ getInfoAnalytes ~ respuesta:", respuesta)

        if (respuesta.code === 200) {

            let listAnalyte1 = [];
           
            if (respuesta.data.length >= 1) {
                respuesta.data.forEach((obj, index) => {


                    let visibleTable = false;


                    listAnalyte1.push({
                        id_info_analyte: obj.id_info_analyte,
                        name: obj.name,
                        code: obj.code,
                        is_interfaced: obj.is_interfaced,
                        visibleTable: visibleTable
                    });
                });
                setAnalytes(listAnalyte1);
                setAnalyteData(listAnalyte1)
            }
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, getInfoAnalytes);

        }
        else if (respuesta.code === 500) {
            createSweet("error", "error", "Analitos", "Ocurrio un problema en el servidor");
        }
        else {
            createSweet("error", "warning", "Analitos", respuesta.data.msg);
            setAnalytes([]);

        }

    }, [history]);

    useEffect(() => {
        getInfoAnalytes();
    }, [getInfoAnalytes]);

    const handleCreate = () => {
        handleUpdateValues({
            name: "",
            code: "",
            is_interfaced: true
        });

        setValidaciones({
            name_valid: false,
            code_valid: false,
        });

        setAnalyteId(0);
        setMethod("create");
        setModalTitle("Nuevo analito");
        toggle();
    }

    const saveCreate = async (e) => {
        e.preventDefault();
        setLoading(true);

        if (validarForm()) {
            setLoading(false);
            return;
        }

        let mValues = JSON.stringify(formValues);

        let requestOptions = {
            method: 'POST',
            body: mValues
        };

        const respuesta = await sendRequest(requestOptions, "InfoAnalyte/CreateAnalyte");

        if (respuesta.code === 200) {
            reset();
            createSweet("create", "success", "Exito!", "Analito creado con exito");
            setLoading(false);
            toggle();
            getInfoAnalytes();
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, saveCreate);
            setLoading(false);
        }
        else if (respuesta.code === 500) {
            createSweet("error", "error", "Analitos", "Ocurrio un problema en el servidor");
            setLoading(false);
        }
        else {
            createSweet("error", "warning", "Analitos", respuesta.data.msg);
            setLoading(false)
        }

    }

    const handleUpdate = (id_info_analyte) => {
        let analyte = analytes.find(x => x.id_info_analyte === parseInt(id_info_analyte));

        handleUpdateValues({
            name: analyte.name,
            code: analyte.code,
            is_interfaced: analyte.is_interfaced
        });

        setValidaciones({
            name_valid: false,
            code_valid: false,
        });

        setAnalyteId(id_info_analyte);
        setMethod("update");
        setModalTitle("Actualizar analito");
        toggle();
    }

    const saveUpdate = async (e, validation = -1) => {
        e.preventDefault();

        setLoading(true);

        if (validarForm()) {
            setLoading(false);
            return;
        }

        if (validation === 0) {
            
            setLoading(false);
            return;
        }

        let body = {
            id_info_analyte: analyteId,
            ...{...formValues}
        };

        let mValues = JSON.stringify(body);

        let requestOptions = {
            method: "PUT",
            body: mValues
        };

        const respuesta = await sendRequest(requestOptions, `InfoAnalyte/UpdateAnalyte?valid_updated=${validation === -1 ? false : validation}`);

        if (respuesta.code === 200) {
            
            let validation = respuesta.data.valid_action;
            let message = respuesta.data.message;

            if (validation && message !== '') {
                
                sweetConfirmationUpdate("Advertencia", message, "warning", saveUpdate, e, true);
                return;
            }
            else if (validation === false && message === "") {
                sweetConfirmationUpdate("Información", "Deseas actualizar el siguiente analito", "warning",saveUpdate, e, true)
                return;
            }
            else
            {
                getInfoAnalytes();
                setLoading(false);                
                createSweet("success", "success", "Info", message);
                toggle();
            }
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, saveUpdate);
            setLoading();
        }
        else if (respuesta.code === 500) {
            createSweet("error", "error", "Analitos", "Ocurrio un error en el servidor");
            setLoading(false);
        }
        else {
            createSweet("error", "warning", "Analitos", respuesta.data.msg);
            setLoading(false);
        }
    }   

    const validarForm = () => {
        let statusValidation = false;
        let newValidations = {};

        if (formValues.name === undefined || formValues.name.length < 3) {
            newValidations = {
                ...newValidations,
                name_valid: true
            };
            statusValidation = true;
        }
        else {
            newValidations = {
                ...newValidations,
                name_valid: false
            }
        }

        if (formValues.code === undefined || formValues.code.length < 2) {
            newValidations = {
                ...newValidations,
                code_valid: true
            };
            statusValidation = true;
        }
        else {
            newValidations = {
                ...newValidations,
                code_valid: false
            }
        }        
        setValidaciones(newValidations);

        return statusValidation;
    }

    const [analyteData, setAnalyteData] = useState([])

    const handleSearch = (e) => {
        let busqueda = e.target.value.toUpperCase();
        let newMethod = [];

        analyteData.forEach(element => {
            let nombre = element.name?.toUpperCase() || "";
            let clave = element.code?.toUpperCase() || "";

            if (nombre.includes(busqueda) || clave.includes(busqueda)) {
                element.visibleTable = true;
                newMethod.push(element);
            } else {
                element.visibleTable = false;
            }
        });

        setAnalytes(newMethod);
    };


    const exportExcel = () => {
        if (!analytes || analytes.length === 0) return;

        const exportData = analytes.map((a, index) => ({
             "#": index + 1,
            Nombre_Analito: a.name,
            Clave: a.code,
            Interfazado: a.is_interfaced ? "Sí" : "No"
        }));

        const worksheet = XLSX.utils.json_to_sheet(exportData);

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Analitos');

        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const dataBlob = new Blob([excelBuffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });

        const fileName = `Analitos.xlsx`;
        const url = window.URL.createObjectURL(dataBlob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    };
    


    return {
        analytes, method, validaciones,
        name, code, is_interfaced,
        handleInputChange, loading,
        toggle, modal, modalTitle,
        handleCreate, saveCreate,
        handleSearch,
        handleUpdate, saveUpdate, exportExcel
    }
};
